<template>
  <div class="digitalize">
    <img class="digitalize-swipe" src="@/assets/images/bg5.png" />
    <!-- <div class="digitalize-content">
      <img
        class="digitalize-bg"
        src="@/assets/images/product/product1-bg.png"
      />
      <div class="digitalize-wrap">
        <div class="digitalize-title">
          <img
            class="digitalize-title-img wow bounceIn"
            src="@/assets/images/product/product1-title.png"
          />
        </div>
        <div class="digitalize-text">
          <div class="digitalize-text-logo">
            <img
              class="digitalize-text-logo wow slideInLeft"
              src="@/assets/images/product/product1-logo.png"
            />
          </div>
          <div class="digitalize-text-text text1 wow slideInDown">
            <span class="digitalize-text-text-title">-城市管理背景</span>
            <span class="digitalize-text-text-content">
              杭州城市发展进入重视数字化城市的发展阶段，对数字化精细化管理需求
              日益增高。城市建设追求品质建设，城市管理趋于场景化、模块化。经济的
              高速发展使得城市空间的复杂度提升，对城市空间的管理方式、管理效率提
              出高要求。
            </span>
          </div>

          <div class="digitalize-text-text text2 wow slideInRight">
            <span class="digitalize-text-text-title">
              -昌恩科技为客户量身定制数字化信息平台
            </span>
            <span class="digitalize-text-text-content">
              政务数字化平台根据“深度”与“广度”出发解决城市管理核心问题，
              契合中国城市管理中的全域感知、实时预警、协同处理、优化贴袋等需求。
            </span>
          </div>

          <div class="digitalize-text-text text3 wow slideInDown">
            <span class="digitalize-text-text-title">
              -政务数字化平台的解决目标
            </span>
            <span class="digitalize-text-text-content">
              政务数字化平台关注人口流动带来的安全、交通拥堵、营商环境治理
              等“城市病”问题。让管理执法人员具备高效运转、敏捷调度等能力。
            </span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="product-content">
      <div class="product-card" id="hos">
        <div class="product-title">好心大夫数字化服务综合平台</div>
        <div class="product-sub-title">
          随着医药带量采购、一致性评价、DRGS等政策的持续推进，特别是近期医药反腐，让药企纷纷聚焦数字化转型。
          向数字化转型既是机遇，也是挑战，选择适合自身战略部署的产品组合才是赋能的新方向。
        </div>
        <div class="product-img">
          <img src="@/assets/images/product/product05.png" alt="" />
        </div>
      </div>
      <div class="product-card oven" id="com">
        <div class="product-title">医药数字化学术营销平台</div>
        <div class="product-sub-title">
          医药数字化营销的内核，主要指药企采用数字系统开展医生虚拟拜访、线上学术会议、
          最新学术进展分析等，对旗下的处方药产品进行在线营销，以提高销量。
        </div>
        <div class="product-img">
          <img src="@/assets/images/product/product07.png" alt="" />
        </div>
      </div>
      <div class="product-card" id="user">
        <div class="product-title">医疗体系数据空间安全平台</div>
        <div class="product-sub-title">
          隐私计算智能服务平台：是以联邦学习FL、安全多方计算MPC、可信硬件执行环境TEE等隐私数据保护技术工具为基础服务的平台
          <br />
          核心价值：保证原始数据不出本地即可完成多方数据联合建模和联合计算能力，同时支持安全隐私保护集合求交、安全隐私查询、安全统计分析。实现各合作机构数据在流通、计算过程中，端到端的安全保护和可审计，推动跨行业的可信数据价值的融合和协同，很好地解决了业界数据孤岛的难题。
        </div>
        <div class="product-img">
          <img src="@/assets/images/product/product06.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
export default {
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
    if (this.$route.query.action) {
      this.goAnchor('#' + this.$route.query.action)
    }
  },
  methods: {
    goAnchor(selector) {
      const element = document.getElementById(selector)
      if (element) {
        element.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.digitalize {
  width: 100%;
  .digitalize-swipe {
    width: 100%;
    object-fit: cover;
    display: block;
  }
  .product-content {
    .product-card {
      padding: 60px 10%;
      box-sizing: border-box;
      &.oven {
        background-color: #f5f5f5;
      }
      .product-title {
        font-size: 36px;
        border-left: 5px solid #b91928;
        height: 40px;
        line-height: 40px;
        text-indent: 20px;
        margin-bottom: 20px;
      }
      .product-sub-title {
        font-size: 24px;
        line-height: 36px;
        padding: 20px 0;
      }
      .product-img {
        width: 100%;
        padding: 40px 0;
        img {
          width: 100%;
          object-fit: cover;
          display: block;
        }
      }
    }
  }
  .digitalize-content {
    position: relative;
    width: 100%;
    .digitalize-bg {
      width: 100%;
      object-fit: cover;
      display: block;
    }
    .digitalize-wrap {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 74px 100px;
      .digitalize-title {
        display: flex;
        justify-content: space-around;
        .digitalize-title-img {
          width: 583px;
          object-fit: cover;
          display: block;
        }
      }
      .digitalize-text {
        margin-top: 82px;
        .digitalize-text-logo {
          width: 498px;
          height: 498px;
        }
        .digitalize-text-text {
          width: 720px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 16px;
          color: #666666;
          line-height: 42px;
          letter-spacing: 6px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          display: flex;
          flex-direction: column;
          .digitalize-text-text-title {
            font-size: 24px;
            color: #b91928;
          }
          .digitalize-text-text-content {
            margin-left: 40px;
            text-indent: 2em;
          }
        }
        .text1 {
          position: absolute;
          top: 250px;
          right: 340px;
        }
        .text2 {
          position: absolute;
          right: 110px;
          bottom: 330px;
        }
        .text3 {
          position: absolute;
          left: 590px;
          bottom: 100px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .digitalize {
    .product-content {
      .product-card {
        padding: 90px;
        .product-title {
          font-size: 86px;
          height: 90px;
          line-height: 90px;
          text-indent: 30px;
          border-width: 16px;
          margin-bottom: 40px;
        }
        .product-sub-title {
          font-size: 72px;
          line-height: 90px;
        }
      }
    }
  }
}
</style>
